import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import ProductGrid from '@/components/products/ProductGrid';
import { productsAPI, categoriesAPI } from '@/lib/api';

export const CategoryPage = () => {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [catResponse, productsResponse] = await Promise.all([
          categoriesAPI.getBySlug(slug),
          productsAPI.getByCategory(slug),
        ]);
        setCategory(catResponse.data);
        setProducts(productsResponse.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  return (
    <Layout>
      {/* Header */}
      <section className="bg-gradient-to-br from-[#0F172A] to-[#1E293B] py-12 md:py-16">
        <div className="container mx-auto px-4 max-w-7xl">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-slate-400 mb-4">
            <Link to="/" className="hover:text-white transition-colors">Início</Link>
            <ChevronRight className="w-4 h-4" />
            <Link to="/categorias" className="hover:text-white transition-colors">Categorias</Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-white">{category?.name || 'Carregando...'}</span>
          </nav>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white">
            {category?.name || 'Carregando...'}
          </h1>
          {category?.description && (
            <p className="text-slate-300 text-lg mt-2 max-w-2xl">
              {category.description}
            </p>
          )}
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12 md:py-16 bg-slate-50">
        <div className="container mx-auto px-4 max-w-7xl">
          <ProductGrid products={products} loading={loading} />
        </div>
      </section>
    </Layout>
  );
};

export default CategoryPage;
